<script lang="ts">
	import type { MouseEventHandler } from "svelte/elements";
	import Button from "./common/Button.svelte";
	import { ButtonSize } from "./common/ButtonSize.js";
	import { ButtonVariant } from "./common/ButtonVariant.js";
	import Formatted from "./common/Formatted.svelte";
	import Icon from "./common/Icon.svelte";

	const {
		checked,
		description,
		icon,
		label,
		onclick,
	}: {
		checked: boolean;
		description: string;
		icon: string;
		label: string;
		onclick: MouseEventHandler<HTMLButtonElement>;
	} = $props();
</script>

<Button
	aria-checked={checked}
	variant={ButtonVariant.Subcategory}
	size={ButtonSize.Custom}
	class={[
		"aria-checked:outline aria-checked:outline-2 aria-checked:outline-fcrdarkgray",
		"p-3 sm:p-4 md:p-5 lg:p-6 [&:is(button)]:rounded-lg w-full",
		"grid grid-cols-[1rem_1fr] gap-x-2 gap-y-1 text-left",
	]}
	{onclick}
>
	<Icon {icon} />
	<span class="text-sm/tighter font-sans font-normal">
		<Formatted text={label} />
	</span>
	<div class="col-span-2 text-fcrgray text-xs/tighter font-sans font-normal">
		<Formatted text={description} />
	</div>
</Button>
